import moment from 'moment';
import { WidgetTypes } from '@helpers/Enums'

export const getMonthName = (monthNumber: number) => {
    switch(monthNumber){
      case 0:
        return 'Jan';
      case 1: 
        return 'Feb';
      case 2:
        return 'Mar';
      case 3:
        return 'Apr';
      case 4:
        return 'May';
      case 5:
        return 'Jun';
      case 6:
        return 'Jul';
      case 7:
        return 'Aug';
      case 8:
        return 'Sep';
      case 9:
        return 'Oct';
      case 10:
        return 'Nov';
      case 11:
        return 'Dec';
    }
  }

  export const getSizeByType = (type: number) => {
    switch(type){
      case WidgetTypes.COUNTER:
        return 6
      case WidgetTypes.LINE_CHART:
        return 24
      case WidgetTypes.LIST:
        return 12
      case WidgetTypes.GROUP:
        return 12
      case WidgetTypes.RANGE_CHART:
        return 24
      case WidgetTypes.BAR_CHART:
        return 24
      case WidgetTypes.GOALS:
        return 6
      case WidgetTypes.TABLE:
        return 12
        case WidgetTypes.GOALS_CHART:
          return 24
      default:
        return
    }
  }


  export const calcFrom = (times: number, type: number) => {
    let date; 

    switch(type){
      case 1: 
        date = moment().subtract(times, 'days')._d
        break;
      case 2:
        date = moment().subtract(times, 'months')._d
        break;
      case 3:
        date = moment().subtract(times, 'years')._d
        break;
      case 4:
        date = moment().subtract(times, 'hour')._d
        break;
      case 5:
        date = moment().subtract(times, 'minutes')._d
        break;
    }

    return date.getTime()
  }